/**
 * Labstep
 */

import EntityActionUpdateTemplate from 'labstep-web/components/Entity/Action/UpdateTemplate';
import type React from 'react';
import type { IResourceActionUpdateResourceTemplateProps } from './types';

export const ResourceActionUpdateResourceTemplate: React.FC<
  IResourceActionUpdateResourceTemplateProps
> = ({ resource, actionType }) => (
  <EntityActionUpdateTemplate
    entity={resource}
    actionType={actionType}
  />
);
